import { DayPicker } from 'react-day-picker';
import { FormatTypes } from '../../../types/formatTypes';
import { format, isValid, parse } from 'date-fns';
import {useFloating} from '@floating-ui/react';
import DateHelper from '../../../helpers/dateHelper';
import FocusTrap from 'focus-trap-react';
import React, {ChangeEventHandler, useRef, useState} from 'react';

export default function DatePicker(props: Props) {
    const [selected, setSelected] = useState<Date>();
    const [inputValue, setInputValue] = useState<string>('');
    const [isPopperOpen, setIsPopperOpen] = useState(false);

    const {
        refs,
        floatingStyles
    } = useFloating({
        placement: 'bottom-start',
    });


    const buttonRef = useRef<HTMLButtonElement>(null);


    const closePopper = () => {
        setIsPopperOpen(false);
        buttonRef?.current?.focus();
    };

    const handleInputChange: ChangeEventHandler<HTMLInputElement> = (e) => {
        setInputValue(e.currentTarget.value);
        const date = parse(e.currentTarget.value, FormatTypes.DATE_FORMAT, new Date());
        if (isValid(date) && e.currentTarget?.value.length === FormatTypes.DATE_FORMAT.length) {
          setSelected(date);
          props.onHandleChange(date);
        } else {
          setSelected(undefined);
        }
    };

    const handleButtonClick = () => {
        setIsPopperOpen(true);
    };

    const handleDaySelect = (selectedDay: Date|undefined)  => {
        if(selectedDay !== undefined) {
            selectedDay = DateHelper.resetTimeZoneOffset(selectedDay);
        }
        setSelected(selectedDay);
        if (selectedDay) {
            setInputValue(format(selectedDay, FormatTypes.DATE_FORMAT));
            props.onHandleChange(selectedDay);
            closePopper();
        } else {
            props.onHandleChange(undefined);
            setInputValue('');
        }
    };

    return (
        <div className="date-picker">
            <div ref={refs.setReference} className="date-picker-input-container">
                <input type="text"
                    className="date-picker-input-container-input"
                    placeholder={props.placeholder}
                    value={inputValue}
                    onChange={handleInputChange}
                />
                <button className="date-picker-input-container-button"
                    ref={buttonRef}
                    onClick={handleButtonClick}>
                     <i className="fas fa-calendar-alt"/>
                </button>
            </div>
            {isPopperOpen && (
                <FocusTrap
                    active
                    focusTrapOptions={{
                        initialFocus: false,
                        allowOutsideClick: true,
                        clickOutsideDeactivates: true,
                        onDeactivate: closePopper,
                        fallbackFocus: buttonRef.current as HTMLButtonElement
                }}>
                    <div
                        tabIndex={-1}
                        style={floatingStyles}
                        className="dialog-sheet"
                        ref={refs.setFloating}
                        role="dialog"
                    >
                        <DayPicker
                            autoFocus={isPopperOpen}
                            mode="single"
                            showOutsideDays
                            showWeekNumber
                            weekStartsOn={1}
                            defaultMonth={selected}
                            selected={selected}
                            onSelect={handleDaySelect}
                        />
                    </div>
                </FocusTrap>)
                }
        </div>);
}

type Props = {
    placeholder: string,
    onHandleChange: (date: Date| undefined) => void
}
